export type BroadcastListener<T> = (ev: MessageEvent<T>) => void

export class Broadcast<T> extends BroadcastChannel {
  messageListeners: Set<BroadcastListener<T>>

  messageErrorListeners: Set<BroadcastListener<T>>

  constructor(name) {
    super(name)
    this.messageListeners = new Set()
    this.messageErrorListeners = new Set()
  }

  postMessage(message: T, postToSelf: boolean = false): void {
    super.postMessage(message)

    const syntheticEvent = new MessageEvent<T>('message', {
      data: message,
      origin: location.origin,
      lastEventId: '',
      source: null,
      ports: [],
    })

    if (postToSelf) {
      for (const listener of this.messageListeners) {
        listener(syntheticEvent)
      }
    }
  }

  addEventListener<K extends keyof BroadcastChannelEventMap>(
    type: K,
    listener: (this: BroadcastChannel, ev: BroadcastChannelEventMap[K]) => any,
    options?: boolean | AddEventListenerOptions,
  ): void {
    super.addEventListener(type, listener, options)

    switch (type) {
      case 'message':
        this.messageListeners.add(listener)
        break
      case 'messageerror':
        this.messageErrorListeners.add(listener)
        break
    }
  }

  removeEventListener<K extends keyof BroadcastChannelEventMap>(
    type: K,
    listener: (this: BroadcastChannel, ev: BroadcastChannelEventMap[K]) => any,
    options?: boolean | AddEventListenerOptions,
  ): void {
    super.removeEventListener(type, listener, options)

    switch (type) {
      case 'message':
        this.messageListeners.delete(listener)
        break
      case 'messageerror':
        this.messageErrorListeners.delete(listener)
        break
    }
  }
}
